/* eslint-disable import/prefer-default-export */

export const appConfig = {
  apiUrl: process.env.REACT_APP_API_URL || '',
};